

import {Component, Vue} from "vue-property-decorator";
import ExportTableHtml from "@/components/ExportTableHtml/index.vue";
import {
  BigAreaData,
  calcMonthTotals,
  convert2DisplayRows, MonthTotal,
  MonthTotalValues
} from "@/views/report/lib/StoreSplitAccountReport";
import api from '@/api/index'
import {StoreSplitAccountReportDto} from "@/api/appService";
import StoreSplitAccountDetail from "@/views/report/component/StoreSplitAccountDetail.vue";
import StoreSplitAmountValueCell from "@/views/report/component/StoreSplitAmountValueCell.vue";


@Component({
  name: "StoreSplitAccountReport",
  components: {StoreSplitAmountValueCell, StoreSplitAccountDetail, ExportTableHtml}
})
export default class StoreSplitAccountReport extends Vue {

  showColumnOfArea: boolean = false;
  showColumnOfPartner: boolean = false;

  year: number = (new Date()).getFullYear();

  loading = false;
  queryCount = 0;

  tableData: BigAreaData[] = []


  monthList = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

  selectedDetail: StoreSplitAccountReportDto | null = null;
  showSelectedDetail = false;

  monthTotalValues:MonthTotalValues = {};

  defaultMonthTotal = {
    income:0,
    month:0,
    splitAmountToStore:0,
    splitAmountToPartialArea:0,
    splitAmountToHeadquarters:0
  }

  allMonthTotal:MonthTotal = {...this.defaultMonthTotal};


  handleSearch() {
    this.loading = true;
    this.queryCount++;
    api.storeSplitAccountReport.getReport({year: this.year}).then(res => {

      this.tableData = convert2DisplayRows(res ?? []);
      this.monthTotalValues = calcMonthTotals(this.tableData);
      this.allMonthTotal = {...this.defaultMonthTotal};
      for(let month of this.monthList) {
        const value = this.monthTotalValues[month];
        this.allMonthTotal.income += value.income;
        this.allMonthTotal.splitAmountToStore += value.splitAmountToStore;
        this.allMonthTotal.splitAmountToHeadquarters += value.splitAmountToHeadquarters;
        this.allMonthTotal.splitAmountToPartialArea += value.splitAmountToPartialArea;
      }
      this.loading = false;
    })
  }

  get showBigAreaColumn() {
    return true;
  }

  get columnWidthConfig() {
    return {
      bigAreaName: 200,
      partialAreaName: 200,
      storeName: 200,
      income: 120,
      splitAmountToHeadquarters: 120,
      splitAmountToPartialArea: 120,
      splitAmountToStore: 120,
    }
  }


  get tableWidth() {
    const config = this.columnWidthConfig;

    let totalWidth = 0;
    if(this.showBigAreaColumn){
      totalWidth += (config.bigAreaName + 1);
    }
    totalWidth += (config.partialAreaName + 1);
    totalWidth += (config.storeName + 2);

    // 从0开始是因为增加了“累计”列
    for(let i=0;i<=12;i++){
      totalWidth += config.income +1;
      totalWidth += config.splitAmountToHeadquarters;
      if(this.showColumnOfArea){
        totalWidth += (1+config.splitAmountToPartialArea);
      }
      if(this.showColumnOfPartner){
        totalWidth += (1+config.splitAmountToStore);
      }

      totalWidth+=2;
    }

    return totalWidth;
  }

  get monthColspan() {
    if (this.showColumnOfPartner && this.showColumnOfArea) {
      return 4;
    } else if (this.showColumnOfPartner || this.showColumnOfArea) {
      return 3;
    } else {
      return 2;
    }
  }


  handleClickAmountCell(dto: StoreSplitAccountReportDto) {
    console.log('handleClickAmountCell', dto);
    this.selectedDetail = dto;
    this.showSelectedDetail = true;
  }

}

